import React, { FC } from 'react';

import { Box } from '../../../atoms/Box';
import { TWizardHeadItemView, WizardHeadItem } from '../_HeadItem/WizardHeadItem';
import type { ICurrentStep, IWizardStep } from '../models';
import { IClassNameProps, ILoadingProps, IStylesProps } from '@src/models/props';

import styled from './WizardHead.scss';

interface IWizardHeadProps extends IClassNameProps, IStylesProps, ILoadingProps {
  steps: IWizardStep[];
  currentStep: ICurrentStep;
  selectCurrentStep: (idx: number) => void;
}

export const WizardHead: FC<IWizardHeadProps> = ({ steps, currentStep, selectCurrentStep }) => {
  return (
    <Box>
      <Box className={styled.root}>
        {steps.map((step, stepIdx) => {
          let view: TWizardHeadItemView = 'inactive';
          if (stepIdx < currentStep.idx) {
            view = 'passed';
          }
          if (step.id === currentStep.step.id) {
            view = 'current';
          }
          return (
            <WizardHeadItem
              key={step.id}
              step={step}
              view={view}
              stepNum={stepIdx + 1}
              selectCurrentStep={selectCurrentStep}
              currentIdx={currentStep.idx}
            />
          );
        })}
      </Box>
    </Box>
  );
};
